<template>

    <div class="ui-table">
        <div class="table-holder">
            <table :class="classes">
                <slot></slot>
            </table>
        </div>

        <div class="table-placeholder" v-if="placeholder"><span>{{ resolvedPlaceholderText }}</span></div>

        <ui-pagination v-if="!placeholder && hasPagination"
                       v-bind="$componentProps('ui-pagination')"
                       @update:page="$emit('update:page', $event)"
                       @update:offset="$emit('update:offset', $event)" />
    </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';
import { isNil, isString } from 'lodash';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { PaginationProps } from '../navigation/Pagination.vue';
import Pagination, { paginationCompMixin } from '../navigation/Pagination.vue';

@Component({
    name: 'ui-table',
    components: {
        'ui-pagination': Pagination
    },
    mixins: [componentPropsMixin, paginationCompMixin],
    emits: ['update:page', 'update:offset']
})
export default class Table extends Vue {

    @Prop({ type: [Boolean, Number, String] })
    placeholder: boolean | number | string;

    @Prop({ type: Boolean })
    clickable: boolean;

    @Prop({ type: String, default: 'normal' })
    theme: string;

    get classes() {

        let classes: string[] = [];

        if(this.clickable){
            classes.push('clickable');
        }

        if(this.theme){
            classes.push('table-' + this.theme);
        }

        return classes;
    }

    get resolvedPlaceholderText() {

        return isString(this.placeholder) ? this.placeholder : this.$t('ui.table.placeholder');
    }

    get hasPagination(): boolean {

        return !isNil(this.paginationProps.total) && !isNil(this.paginationProps.limit);
    }

    get paginationProps(): PaginationProps {
        return this as any
    }
}

export type TableComp = InstanceType<typeof Table>
export type TableProps = ComponentProps<TableComp> & PaginationProps
export const tableCompMixin = createComponentMixin(Table, paginationCompMixin)

</script>
<style src="../../../scss/component/table/Table.scss" lang="scss"></style>